// noinspection JSUnusedGlobalSymbols
export default () => ({
    lastDryRun: null,
    lastSyncResult: null,
    mocoSettings: null,
})
